import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type DownloadIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function DownloadIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: DownloadIconProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M8 10.158V2.142"
        className={pathClassName}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <Path
        d="M4.918 7.33l2.644 2.643a.625.625 0 00.879 0l2.644-2.644"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.832 9.233v3.084a1.542 1.542 0 001.542 1.541h9.25a1.542 1.542 0 001.541-1.541V9.233"
        stroke="transparent"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default DownloadIcon;
